import { Type } from '@sinclair/typebox';
import { GeoConversionTypes } from '../../enums/GeoConversionTypes';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { makeNullable } from '../../utils/typeboxHelpers';
import { JobStates } from '../job/JobStates';
import { JobTypes } from '../job/JobTypes';

export const workerPaths = {
    '/api/surveys/{surveyId}/jobs/{jobType}/finishUpload': {
        parameters: [createPathGuidParameter('surveyId'), { name: 'jobType', in: 'path', required: true, schema: Type.Enum(JobTypes) }],
        post: {
            operationId: 'workerControllers.finishUpload',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            assetId: Type.String(),
                            filename: Type.String(),
                            filesize: Type.Number(),
                            objectId: Type.String(),
                            options: Type.Object({
                                geoConversionType: Type.Optional(Type.Enum(GeoConversionTypes)),
                                utmZone: Type.Optional(Type.String()),
                            }),
                        }),
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/jobs/{jobType}/status': {
        parameters: [createPathGuidParameter('surveyId'), { name: 'jobType', in: 'path', required: true, schema: Type.Enum(JobTypes) }],
        get: {
            operationId: 'workerControllers.getStatus',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                status: Type.Enum(JobStates),
                                message: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/workers/admin/jobs': {
        get: {
            operationId: 'workerApiControllers.adminGetJobs',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),
                                    surveyId: Type.String(),
                                    jobType: Type.String(),
                                    payload: Type.Object({
                                        assetId: Type.Optional(Type.String()),
                                        objectId: Type.Optional(Type.String()),
                                        surveyId: Type.Optional(Type.String()),
                                        filename: Type.Optional(Type.String()),
                                        filesize: Type.Optional(Type.Number()),
                                        conversionType: Type.Optional(Type.String()),
                                        geoConversionType: Type.Optional(Type.Optional(Type.String())),
                                        utmZone: Type.Optional(Type.Optional(Type.String())),
                                    }),
                                    workerId: makeNullable(Type.String()),
                                    message: Type.String(),
                                    startedOnDateTime: makeNullable(Type.String()),
                                    updatedOnDateTime: makeNullable(Type.String()),
                                    created_at: Type.String(),
                                    updated_at: Type.String(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/workers/admin/finishedJobs': {
        get: {
            operationId: 'workerControllers.adminGetFinishedJobs',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    created_at: Type.String(),
                                    id: Type.String(),
                                    surveyId: Type.String(),
                                    wasSuccessful: Type.Boolean(),
                                    jobType: Type.String(),
                                    workerId: makeNullable(Type.String()),
                                    startedOnDateTime: Type.String(),
                                    errorLog: makeNullable(Type.String()),
                                    log: makeNullable(Type.String()),
                                    updated_at: Type.String(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/workers/jobs/{jobId}': {
        parameters: [createPathGuidParameter('jobId')],
        delete: {
            operationId: 'workerControllers.deleteJob',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
